import { render, staticRenderFns } from "./fixed-bottom.vue?vue&type=template&id=3cf5edff&scoped=true&"
import script from "./fixed-bottom.vue?vue&type=script&lang=js&"
export * from "./fixed-bottom.vue?vue&type=script&lang=js&"
import style0 from "./fixed-bottom.vue?vue&type=style&index=0&id=3cf5edff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf5edff",
  null
  
)

export default component.exports